import { Component, AfterViewInit, OnInit, ChangeDetectorRef, ElementRef, ViewChild, Renderer } from '@angular/core';

import {Title } from '@angular/platform-browser';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';
import { RestService } from '../services/rest.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';


@Component({
  selector: 'gas',
  providers: [StorageService, RestService],
  templateUrl: './gas.component.html',
  styleUrls: ['./gas.component.scss']
})
export class GasComponent implements AfterViewInit, OnInit {

  private storage: any = null;
  private container: any = null;
  private mainContainer: any = null;
  private order: any = null;
  private mogid: string;
  storages: any[];
  articles: any[];
  relatedArticleList: any[] = [];
  relatedOrderList: any[] = [];
  loadArticles: boolean = false;
  loadArticleList: boolean = false;

  mainContainerName: string;
  lineHaulName: string;
  containerEmpty: string = '';
  scannedValue: string = null;
  scannedSaveValue: string = null;
  parcelCode: string;
  tracking: any;
  
  status: string;
  clearedStatus: string = null;
  
  validatedContainerName: boolean = false;
  
  loadedParcel: boolean = false;
  loadedContainer: boolean = false;
  loadedMainContainer: boolean = false;

  filteredStorages: any[];
  filterTitle: string;
  filterString: string = '';

  activeOtherArticles: boolean = false;
  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _restService: RestService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    public renderer: Renderer) {
  }

  @ViewChild('ft01') infocus: ElementRef;

  ngOnInit(): void {
    this._titleService.setTitle('GAS Item');
    this.load();
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('gas.list');
      this.loadFilter('All GAS items');    
    } catch (error) {

    } finally {
      this._loadingService.resolve('gas.list');
    }
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  async loadValue(value: string): Promise<void> {
    try {
      // check if the value is a parcel(hawb or barcode) or a containerName
      // scanned containerNames may have the form 'LcontainernameX', so first we set to upper case and remove L and X
      // containerNames are less than 10 characters long
      this.scannedValue = value.toUpperCase();
      this.scannedValue = this.scannedValue.replace(/^L|X$/g, '')

      // if it is a container or shelf we need to have a loaded parcel to be stored
      if (this.scannedValue.length <= this._storageService.containerNameBarcodeMaxLength) {
          await this.loadContainer(this.scannedValue); // validate container
          if (this.loadedParcel) {
            if (this.handleLoadedParcel()) {
              // do not clear all loaded values. Let order information but remove articles
              this.loadArticles = false;
              this.loadArticleList = false;
              this.clearedStatus = 'hide';
              this.loadedParcel = false;
            }
          } else {
            this._dialogService.openAlert({ message: 'Cannot assign container if no loaded parcel exists!'});
            this.goBack();
          }
      } else { // if it is a parcel
          // if a parcel was already loaded => handle loaded parcel
          if (this.isParcelLoaded()) {
            if (this.handleLoadedParcel()) {
              // clear loaded values
              this.clearForm();
              // load the new parcel
              await this.loadParcel(this.scannedValue);
            } else {
              this._dialogService.openAlert({ message: 'Parcel cannot be scanned to main container or no existing container scanned!' });
              this.scannedValue = null; 
              this.load();
            }
          } else {
            // clear loaded values
            this.clearForm();
            // load the new parcel
            await this.loadParcel(this.scannedValue);
          }
      }
      this.scannedSaveValue = this.scannedValue;
      this.scannedValue = null;
    } catch (error) {
      this.status = 'none';
      this.loadedParcel = false;
      this.scannedValue = null;
    } finally {
    }
  }

  async loadParcel(tracking: string): Promise<void> {
    try {
      // get status from storage service: TAXATION, ECOMM_ARRIVE, ECOMM_RETURN, ECOMM_COMPLETE, ECOMM_DONE or READY_TO_SHIP
      // get info from storage service
      // if ECOMM_COMPLETE => OK we can store in container for Export
      // if not ECOMM_COMPLETE => store in warehouse or handle errors

      await this.getParcel(tracking);
      if (!this.storage) { // probably parcel does not exist in App!!
        this.clearedStatus = null;
        this.loadedParcel = true;
        this.parcelCode = tracking;
      } else {
        if (this.storage.businessKey) { 
          // load parcel details (consignee name and articles)
          await this.getParcelDetails(this.storage.businessKey);
        } else {
          // do nothing, gas scan without order, like relax days
        }

        if (this.storage && this.storage.containerName) {
            this.status = 'stored';
        } else if (this.storage && !this.storage.containerName) {
            this.status = 'none';
        } 
        this.clearedStatus = this.storage.workflowStatus;
        this.parcelCode = tracking;
        this.loadedParcel = true;
        if (this.storage.businessKey) { 
          this.loadArticles = true;
        } else {
          this.loadArticles = false; // gas scan without order, like relax days
        }
      }
    } catch (error) {
      this.status = 'none';
      this.loadedParcel = false;
      this.loadArticles = false;
      this.loadArticleList = false;
    } finally {
    }
  }

  async getParcelDetails(businessKey: string): Promise<void> {
    try{
        let orderList = await this._storageService.getDetailsByBusinessKeyReader(businessKey).toPromise();
        if (orderList) {this.order = orderList[0];}
        if (this.order) {
          this.mogid = this.order.mogid;
        }
        
    } catch (error) {
        console.log('Cannot get order details!');
        this.storage = null;
    } finally {
    }
  }

   handleLoadedParcel(): boolean {
    try {
      
      // if ecomm_complete or ecomm_done => send to exception (how to handle this exception?) => the new scanned value must be a container
      // if ecomm_arrived => send to exception (how to handle this exception?) => the new scanned value must be a container
      // if not ecomm_arrived, not ecomm_complete, not ecomm_done => store to warehouse => the new scanned value must be a container
      // if order not found => send to exception (here we could open the package, scan the items and "create the order") => the new scanned value must be a container
      
      // if ready for export
      if (this.getClearedStatus() == 'ready') {
            // if we scanned a new parcel or if we scanned the main container
            if (!this.container || this.container.name.toUpperCase().indexOf(this.mainContainerName.toUpperCase()) > -1) {
              let order = {
                reference: this.storage.reference,
                businessKey: this.storage.businessKey,
                projectId: this.storage.projectId
              }
              let tracking = this.parcelCode;
              let orderTrackingItem = {
                tracking: tracking,
                order: order
              }
              this.save('ready', null);
              return true;
            // if we scanned a different container
            } else {
              this._dialogService.openAlert({ message: 'Parcel will be stored to container ' + this.container.name + ' and not to main container!' });
              this.save('store');
              return true;
            }
      }  
      
      // if gas scan without order, like relax days we can't store this way, it needs to be done with the articles button
      else if (this.getClearedStatus() == 'missing_online_return' && !this.order) {
          this._dialogService.openAlert({ message: 'You need to scan the articles and press the CONFIRM button!' });
          return false;
      }
      
      // if no online return
      else if (this.getClearedStatus() == 'missing_online_return') {
            // if we scanned a new parcel or if we scanned the main container
            if (!this.container || this.container.name.toUpperCase().indexOf(this.mainContainerName.toUpperCase()) > -1) {
              return false;
              // if we scanned a different container
            } else {
              this.save('missing_online_return');
              return true;
            }
      }
      
      // if order already processed 
      else if (this.getClearedStatus() == 'process_finished') {
            // if we scanned a new parcel or if we scanned the main container
            if (!this.container || this.container.name.toUpperCase().indexOf(this.mainContainerName.toUpperCase()) > -1) {
              return false;
              // if we scanned a different container
            } else {
              this.save('process_finished');
              return true;
            }
      }

      // if order not found      
      else if (this.getClearedStatus() == 'not_found') {
            // if we scanned a new parcel or if we scanned the main container
            if (!this.container || this.container.name.toUpperCase().indexOf(this.mainContainerName.toUpperCase()) > -1) {
              return false;
              // if we scanned a different container
            } else {
              this.save('not_found');
              return true;
            }
      }
      
      // if order already stored
      else if (this.getClearedStatus() == 'export_ready') {
            // if we scanned a new parcel or if we scanned the main container
            if (!this.container || this.container.name.toUpperCase().indexOf(this.mainContainerName.toUpperCase()) > -1) {
              this.save('multipiece');
              return true;
            // if we scanned a different container
            } else {
              this._dialogService.openAlert({ message: 'Parcel will be stored to container ' + this.container.name + ' and not to main container!' });
              this.save('store');
              return true;
            }
      }

    } catch (error) {
      this.status = 'none';
      this.loadedParcel = false;
    } finally {
    }
  }

  async getParcel(reference: string): Promise<void> {
    try{
        this.storages = await this._storageService.getParcel(reference).toPromise();
        if (this.storages.length == 0) {
            this.storage = null;
        } else {
            // if routing information exists it must match the line_haul
            this.tracking = await this._restService.getTracking(reference).toPromise();
            let trackingItemInfo = await this._restService.getTrackingItemInfo(this.tracking.id).toPromise();
            if (trackingItemInfo && (!trackingItemInfo.routingInformation 
                                  || trackingItemInfo.routingInformation != this.lineHaulName) ) {
              //throw error and not load parcel
              this._dialogService.openAlert({ message: 'Container Line haul (' + this.lineHaulName + ') does not match parcel routing information (' + trackingItemInfo.routingInformation + ')' });
            } else {

              for (let element of this.storages) {
                  if (element.workflowStatus == 'ECOMM_COMPLETE') {
                      this.storage = element;
                      break;
                  } else if (element.workflowStatus == 'ECOMM_RETURN') {
                      this.storage = element;
                      break;
                  }
              }
              if (!this.storage) {
                  this.storage = this.storages[0];
              }
            }
        }
    } catch (error) {
        console.log('Cannot get parcel!');
        this.storage = null;
    } finally {
    }
  }

  async loadContainer(containerName: string): Promise<void> {
    try {
      //validate container: it must exist
      this.container = await this._storageService.getContainer(containerName).toPromise();
      if (this.container.containerStatus == 'OPEN') {
        this.loadedContainer = true;
      } else {
        this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.mainContainer.containerStatus });
        this.loadedContainer = false;
      }
    } catch (error) {
      //container does not exist
      this.loadedContainer = false;
    } finally {
    }
  }

  async loadMainContainer(mainContainerName: string): Promise<void> {
    try {
      //validate container: it must exist
      this.mainContainer = await this._storageService.getContainer(mainContainerName).toPromise();
      if (this.mainContainer.containerStatus == 'OPEN') {
        this.mainContainerName = this.mainContainer.name;
        this.loadedMainContainer = true;
        // Get line haul
        let addInfoItem: any = this.mainContainer.addInfo.find(element => element.keyValue == 'line_haul');
        this.lineHaulName = addInfoItem.textValue;

      } else {
        this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.mainContainer.containerStatus });
        this.loadedMainContainer = false;
      }
    } catch (error) {
      //container does not exist
      this.loadedMainContainer = false;
    } finally {
    }
  }

  getStatus() {
    return this.status;
  }

  getClearedStatus() {
    if (this.clearedStatus == 'ECOMM_RETURN') {
      return 'ready';
    } else if (this.clearedStatus == 'ECOMM_COMPLETE') {
      return 'export_ready';
    } else if (this.clearedStatus == 'ECOMM_DONE') {
      return 'process_finished';
    } else if (this.clearedStatus && (this.clearedStatus == 'TAXATION' || this.clearedStatus == 'ECOMM_ARRIVED')) {
      return 'missing_online_return';
    } else if (!this.clearedStatus) {
      return 'not_found';
    }
    return this.clearedStatus;
  }

  getArticleList() {
    // get related orders for this businesskey
    //this.relatedOrderList = await this._storageService.getRelatedOrdersByBusinessKeyReader(this.order.businessKey).toPromise();
    
    this._loadingService.register("otherArticles");
    this.activeOtherArticles = true;
    this._storageService.getRelatedOrdersByBusinessKeyReader(this.order.businessKey)
      .subscribe(data => {
        this.relatedOrderList = data;
        // get articles for those orders
        this.relatedArticleList = [];
        for (let element of data) {
          this._restService.getArticles(element.businessKey, element.projectId)
            .subscribe(articleArray => {
              for (let articleItem of articleArray) {
                this.relatedArticleList.push(articleItem);
              }
            });
        }
        this.loadArticleList = true;
    },
    err => console.log(err.message));
    this._loadingService.resolve("otherArticles"); 
  }

  isMainContainerLoaded() {
    return this.loadedMainContainer;
  }

  isParcelLoaded() {
    return this.loadedParcel;
  }

  keytab(event, from: string, innerText: string) {
    if (from == 'mainContainerName') {
      this.loadMainContainer(this.mainContainerName);
    } else if (from == 'scannedValue') {
      this.loadValue(this.scannedValue)
    }

    let path = event.composedPath();
    let element = path[5]; // naviagte to md-card-content

    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (element.children[j].innerText == innerText) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }
  
  async save(action: string, orderReady: any = null, articleList: any[]= null): Promise<void> { // orderReady = {"tracking": tracking, "order": {...}}
    try {
        if (action == 'ready') {
          if (orderReady) {
            let storage = {
              itemCount: 1,
              containerName: this.mainContainerName,
              reference: orderReady.order.reference,
              storeUser: null,
              storeDate: new Date(),
              businessKey: orderReady.order.businessKey,
              projectId: orderReady.order.projectId
            }
            let res = await this._storageService.updateStorageByBusinesskey(storage, 'GAS_RETURN', orderReady.tracking).toPromise();
          } else {
            let storage = {
              itemCount: 1,
              containerName: this.mainContainerName,
              reference: this.storage.reference,
              storeUser: null,
              storeDate: new Date(),
              businessKey: this.storage.businessKey,
              projectId: this.storage.projectId
            }
            let res = await this._storageService.updateStorageByBusinesskey(storage, 'GAS_RETURN', this.parcelCode).toPromise();
          }
          if (this.storage!=null) {
            this.storage.containerName = this.mainContainerName;
          }
        } else if (action == 'store') {
            let storage = {
              itemCount: 1,
              containerName: this.container.name,
              reference: this.storage.reference,
              storeUser: null,
              storeDate: new Date(),
              businessKey: this.storage.businessKey,
              projectId: this.storage.projectId
            }
            let res = await this._storageService.updateStorageByBusinesskey(storage, 'GAS_RETURN', this.parcelCode).toPromise();
            if (this.storage!=null) {
              this.storage.containerName = this.container.name;
            }
        } else if (action == 'store_no_order') {
          // do not create GAS_RETURN event. It can't be processed later by the scheduler since order does not exist
          if (articleList) { 
            /*
            let storage = {
              itemCount: 1,
              containerName: this.mainContainerName,
              reference: this.storage.reference,
              storeUser: null,
              storeDate: new Date(),
              businessKey: this.storage.businessKey,
              projectId: this.storage.projectId
            }
            let res = this._storageService.updateStorage(storage, 'GAS_RETURN').toPromise();
            */
            if (this.storage!=null) {
              this.storage.containerName = this.mainContainerName;
            }
            for (let article of articleList) {
              let restScanEvent = {
                eventDate: new Date(),
                source: 'INTERNAL',
                reference: this.storage.reference,
                status: 'GAS_RETURN_ARTICLES',
                remark: article.reference,
                internal: false,
                description: null // THEY SHOULD LOG IN WITH THE RIGHT CLIENT!!! CLIENT NEEDED TO RETRIEVE EVENTS
              }
              this._restService.createEvent(restScanEvent).toPromise();
            }
          } else { // if no articles were scanned, we can't store the parcel. We should not arrive here
            this._dialogService.openAlert({ message: 'The list of articles need to be scanned!'});
          }
        }  else if (action == 'missing_online_return') {
            let exception = {
                reference : this.storage.reference,
                code : this.parcelCode,
                exceptionDate : new Date(),
                exceptionType : 'MISSING_ONLINE_RETURN',
                exceptionStatus : 'OPEN',
                containerName : this.container.name
            }
            this.sendToException(exception);
            let storage = {
              itemCount: 1,
              containerName: this.container.name,
              reference: this.storage.reference,
              storeUser: null,
              storeDate: new Date(),
              businessKey: this.storage.businessKey,
              projectId: this.storage.projectId
            }
            if (this.storage.workflowStatus == 'TAXATION') {
              await this._storageService.updateStorageByBusinesskey(storage, 'GAS_RETURN', this.parcelCode).toPromise();
            } else if (this.storage.workflowStatus == 'ECOMM_ARRIVED') {
              await this._storageService.updateStorageByBusinesskey(storage, 'UPDATE_WAREHOUSEITEM', this.parcelCode).toPromise();
            }
            if (this.storage!=null) {
              this.storage.containerName = this.container.name;
            }
        } else if (action == 'process_finished') { //Order already processed
            let exception = {
                reference : this.storage.reference,
                code : this.parcelCode,
                exceptionDate : new Date(),
                exceptionType : 'PROCESS_FINISHED',
                exceptionStatus : 'OPEN',
                containerName : this.container.name
            }
            this.sendToException(exception);
        } else if (action == 'not_found') {
            let exception = {
                reference : null,
                code : this.parcelCode,
                exceptionDate : new Date(),
                exceptionType : 'NOT_FOUND',
                exceptionStatus : 'OPEN',
                containerName : this.mainContainerName
            }
            this.sendToException(exception);
        } else if (action == 'multipiece') {
          /* This is no longer considered an exception
            let exception = {
                reference : this.storage.reference,
                code : this.parcelCode,
                exceptionDate : new Date(),
                exceptionType : 'MULTIPIECE',
                exceptionStatus : 'OPEN',
                containerName : this.container.name
            }
            this.sendToException(exception);
            */
            let storage = {
              itemCount: 1,
              containerName: this.mainContainerName,
              reference: this.storage.reference,
              storeUser: null,
              storeDate: new Date(),
              businessKey: this.storage.businessKey,
              projectId: this.storage.projectId
            }
            await this._storageService.updateStorageByBusinesskey(storage, 'UPDATE_WAREHOUSEITEM', this.parcelCode).toPromise();
            //if (this.storage!=null) {
            //  this.storage.containerName = this.mainContainerName;
            //}
        }
    } catch (error) {
        this._dialogService.openAlert({ message: 'Store parcel failed!'});
    } finally {
    }
  }

  async sendToException(exception: any): Promise<void> {
      try {
          let res= await this._storageService.sendToException(exception).toPromise();
      } catch(error) {
        this._dialogService.openAlert({ message: 'Exception not set!' });
      } finally {
      }
  }

  goBack(): void {
    this.clearForm();
    this.scannedValue = null;
    this._router.navigate(['/gaschoice/gas']);
    this.activeOtherArticles = false;
  }

  clearForm() {
    this.parcelCode = null;
    this.storage = null;
    this.container = null;
    this.status = null;
    this.clearedStatus = null;
    this.mogid = null;
    this.loadedParcel = false;
    this.loadArticles = false;
    this.loadArticleList = false;
    this.relatedArticleList = [];
    this.relatedOrderList = [];
    this.load();
  }

  async saveArticles(event) {
    for (let orderReady of event.get('ready')) { // orderReady = {"tracking": tracking, "order": {...}}
      await this.save('ready', orderReady);
    }
    // do not clear all loaded values. Let order information but remove articles
    this.loadArticles = false;
    this.loadArticleList = false;
    this.clearedStatus = 'hide';
    this.loadedParcel = false;
    this.scannedValue = null;
    this.relatedArticleList = [];
    this.relatedOrderList = [];
  }

  async saveNewArticles(event) {
    //event => articles = [{reference: xyz}, {reference: abc}, ...]
    
    await this.save('store_no_order', null, event);
    // do not clear all loaded values. Let order information but remove articles
    this.loadArticles = false;
    this.loadArticleList = false;
    this.clearedStatus = 'hide';
    this.loadedParcel = false;
    this.scannedValue = null;
    this.relatedArticleList = [];
    this.relatedOrderList = [];
    this.load();
  }

  cancelArticles(articles: any) {
    //this.articles = articles;
  }

  cancelNewArticles(articles: any) {
    //this.articles = articles;
  }



}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/gas/gas.component.ts